"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Card = void 0;
var mdbreact_1 = require("@aon/mdbreact");
var React = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var globalVars_module_scss_1 = __importDefault(require("../../globalVars.module.scss"));
var hideHeader = (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t.card-header {\n\t\tdisplay: none !important;\n\t}\n"], ["\n\t.card-header {\n\t\tdisplay: none !important;\n\t}\n"])));
// Styled Card
var TwsCard = (0, styled_components_1.default)(mdbreact_1.Card).attrs({
    className: 'tws-card',
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\t&.card {\n\t\tbox-shadow: ", ";\n\t\t-webkit-box-shadow: ", ";\n\t\tfont-weight: inherit;\n\t\tborder-radius: ", ";\n\t\tmin-height: 600px;\n\t\tmargin-bottom: 20px;\n\t}\n\t.card-header {\n\t\tdisplay: ", ";\n\t\talign-items: ", ";\n\t\tborder-bottom: ", " ", " ", ";\n\t\tbackground: ", ";\n\t\tpadding-left: 30px;\n\t\tpadding-right: 16px;\n\t\theight: 70px;\n\t\t.card-title {\n\t\t\tfont-weight: ", ";\n\t\t\tcolor: ", ";\n\t\t\tpadding: ", ";\n\t\t\tmargin: ", ";\n\t\t\tfont-size: 20px;\n\t\t\tline-height: 1.1em;\n\t\t}\n\t\t@media (min-width: 0) and (max-width: 768px) {\n\t\t\theight: ", " !important;\n\t\t\tdisplay: ", " !important;\n\t\t\tpadding: 25px 20px;\n\t\t\t.card-title {\n\t\t\t\tmargin-bottom: 0;\n\t\t\t}\n\t\t}\n\t}\n\t.card-body {\n\t\tpadding: ", " ", ";\n\t}\n\t@media (min-width: 0) and (max-width: 768px) {\n\t\t.card-body {\n\t\t\tpadding: ", ";\n\t\t}\n\t}\n\t", "\n"], ["\n\t&.card {\n\t\tbox-shadow: ", ";\n\t\t-webkit-box-shadow: ", ";\n\t\tfont-weight: inherit;\n\t\tborder-radius: ", ";\n\t\tmin-height: 600px;\n\t\tmargin-bottom: 20px;\n\t}\n\t.card-header {\n\t\tdisplay: ", ";\n\t\talign-items: ", ";\n\t\tborder-bottom: ", " ", " ", ";\n\t\tbackground: ", ";\n\t\tpadding-left: 30px;\n\t\tpadding-right: 16px;\n\t\theight: 70px;\n\t\t.card-title {\n\t\t\tfont-weight: ", ";\n\t\t\tcolor: ", ";\n\t\t\tpadding: ", ";\n\t\t\tmargin: ", ";\n\t\t\tfont-size: 20px;\n\t\t\tline-height: 1.1em;\n\t\t}\n\t\t@media (min-width: 0) and (max-width: 768px) {\n\t\t\theight: ", " !important;\n\t\t\tdisplay: ", " !important;\n\t\t\tpadding: 25px 20px;\n\t\t\t.card-title {\n\t\t\t\tmargin-bottom: 0;\n\t\t\t}\n\t\t}\n\t}\n\t.card-body {\n\t\tpadding: ", " ", ";\n\t}\n\t@media (min-width: 0) and (max-width: 768px) {\n\t\t.card-body {\n\t\t\tpadding: ", ";\n\t\t}\n\t}\n\t", "\n"])), globalVars_module_scss_1.default.shadow1, globalVars_module_scss_1.default.shadow1, globalVars_module_scss_1.default.borderRadius4, globalVars_module_scss_1.default.displayFlex, globalVars_module_scss_1.default.alignCenter, globalVars_module_scss_1.default.borderThin, globalVars_module_scss_1.default.borderSolid, globalVars_module_scss_1.default.gray3, globalVars_module_scss_1.default.noBackground, globalVars_module_scss_1.default.fontWeightBold, globalVars_module_scss_1.default.mainGray, globalVars_module_scss_1.default.spacing0, globalVars_module_scss_1.default.noMargin, globalVars_module_scss_1.default.heightAuto, globalVars_module_scss_1.default.displayBlock, globalVars_module_scss_1.default.spacing50, globalVars_module_scss_1.default.spacing30, globalVars_module_scss_1.default.spacing20, function (props) { return (props.noheader === 'yes' ? hideHeader : null); });
TwsCard.displayName = 'TwsCard';
var Card = /** @class */ (function (_super) {
    __extends(Card, _super);
    function Card() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Card.prototype.render = function () {
        return (React.createElement(TwsCard, __assign({}, this.props, { className: this.props.className }), this.props.children));
    };
    return Card;
}(React.Component));
exports.Card = Card;
var templateObject_1, templateObject_2;
